import { useEffect } from "react";
import { getLinkStore, getStore } from "../../utils/platform";
import "./style.css";

interface Props {
    setIsOpenNewVersion: (val: boolean) => void
    loadPosts: (number: number) => void
}

export default function NewVersionAvaliable({ setIsOpenNewVersion, loadPosts }: Props){
    const hide = () => {
        loadPosts(0);
        setIsOpenNewVersion(true);
        sessionStorage.setItem("newVersionOpen", String(true));
    }

    return (
        <>
            <div className="bg-modal" onClick={hide} />
            <div className="container-new-version">
                <div className="content-new-version">
                    <h1>Nova versão disponível</h1>
                    <p>Atualize o Paçoca na { getStore() } para ter acesso as novidades e correções de bugs!</p>

                    <a onClick={hide} href={getLinkStore()} target="_blank" className="btn btn-blue btn-w-100 mt-3">
                        Atualizar
                    </a >

                    <div onClick={hide} style={{ width: "100%" }} className="w-100 text-center mt-3 link cursor-pointer">Baixar depois</div>
                </div>
            </div>
        </>
    );
}